(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artist-directory"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.artist-directory');
    if (!root) return;

    var input = root.querySelector('[data-artist-search]');
    var empty = root.querySelector('[data-artist-empty]');
    var topBtn = root.querySelector('[data-artist-top]');
    var groups = Array.from(root.querySelectorAll('.artist-group'));

    var linkByGroup = {};
    root.querySelectorAll('.artist-index__link').forEach(function (link) {
      var href = link.getAttribute('href');
      if (href && href.charAt(0) === '#') linkByGroup[href.slice(1)] = link;
    });

    // The site header is sticky; a jump must clear its real height,
    // measured at click time (announcement bar has scrolled away).
    function headerHeight() {
      var header = document.querySelector('store-header.header') ||
                   document.querySelector('store-header');
      return header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    }

    var indexNav = root.querySelector('.artist-index');
    if (indexNav) {
      indexNav.addEventListener('click', function (e) {
        var link = e.target.closest('a.artist-index__link');
        if (!link) return;
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();

        // One computed scroll so global smooth-scroll animates once
        // to the right place, instead of two steps racing.
        var y = window.scrollY + target.getBoundingClientRect().top
                - headerHeight() - 24;
        window.scrollTo({ top: y, behavior: 'smooth' });
        history.replaceState(null, '', '#' + id);
      });
    }

    function applyFilter(term) {
      term = term.trim().toLowerCase();
      var anyVisible = false;

      groups.forEach(function (group) {
        var groupHasMatch = false;

        group.querySelectorAll('.artist-card').forEach(function (card) {
          var nameEl = card.querySelector('.artist-card__name');
          var name = nameEl ? nameEl.textContent : '';
          var match = !term || name.toLowerCase().indexOf(term) !== -1;
          card.hidden = !match;
          if (match) groupHasMatch = true;
        });

        group.hidden = !groupHasMatch;
        if (groupHasMatch) anyVisible = true;

        var link = linkByGroup[group.id];
        if (link && link.tagName === 'A') {
          link.style.opacity = groupHasMatch ? '' : '0.25';
          link.style.pointerEvents = groupHasMatch ? '' : 'none';
        }
      });

      if (empty) empty.classList.toggle('is-visible', !anyVisible);
    }

    if (input) {
      input.addEventListener('input', function () {
        applyFilter(input.value);
        updateActiveLetter();
      });
    }

    var activeLink = null;
    function setActive(id) {
      var link = linkByGroup[id];
      if (link === activeLink) return;
      if (activeLink) activeLink.classList.remove('is-active');
      if (link) link.classList.add('is-active');
      activeLink = link;
    }

    var observer = new IntersectionObserver(function (entries) {
      var visible = entries
        .filter(function (e) { return e.isIntersecting && !e.target.hidden; })
        .sort(function (a, b) {
          return a.boundingClientRect.top - b.boundingClientRect.top;
        });
      if (visible.length) setActive(visible[0].target.id);
    }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });

    function updateActiveLetter() {
      var firstVisible = groups.find(function (g) { return !g.hidden; });
      if (firstVisible) setActive(firstVisible.id);
    }

    groups.forEach(function (g) { observer.observe(g); });

    if (topBtn) {
      topBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      window.addEventListener('scroll', function () {
        topBtn.classList.toggle('is-visible', window.scrollY > window.innerHeight);
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
